import { PhoneCall } from "lucide-react";
import s from "../steps.module.css";

interface GarageCallLinkProps {
  phone?: string;
  locationName?: string;
  reason: string;
}

/** Direct phone fallback for journeys Garage Hive cannot complete online. */
export function GarageCallLink({
  phone,
  locationName,
  reason,
}: GarageCallLinkProps) {
  if (!phone) return null;

  const dialNumber = phone.replace(/[^+\d]/g, "");
  const location = locationName ? ` ${locationName}` : " the garage";

  return (
    <a className={s.garageCallLink} href={`tel:${dialNumber}`}>
      <PhoneCall size={18} aria-hidden="true" />
      <span>
        <strong>{reason}</strong>
        <small>
          Call{location} on {phone}
        </small>
      </span>
    </a>
  );
}
